import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { InitAction } from "../actions";
import * as initApi from "../api/init";
import { toastr } from "react-redux-toastr";
import { deleteCookie } from "../lib/cookie";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherInit() {
  yield takeLatest(types.INIT_REQUEST, worker);
  yield takeLatest(types.INIT_HELP_STATUS, helpStatus);
}

function fetchInit() {
  return initApi.init();
}

function* worker() {
  try {
    const response = yield call(fetchInit);
    const data = response.data;
    if (data.data && data.data.project && data.data.project.is_archived) {
      throw {
        m:
          "پروژه به لیست آرشیوها منتقل شده است. لطفا یک پروژه دیگر را انتخاب کنید."
      };
    }
    localStorage.setItem(
      "project_info",
      JSON.stringify({
        ...data.data.project,
        is_owner: data.data.is_owner
      })
    );
    localStorage.setItem("currency", data.currency);
    localStorage.setItem("use_imprest", data.project_setting.use_imprest);
    localStorage.setItem(
      "construction_component_level",
      data.project_setting.construction_component_level
    );
    localStorage.setItem(
      "construction_phase_level",
      data.project_setting.construction_phase_level
    );
    localStorage.setItem("unread_notifications_num", data.notification_count);
    localStorage.setItem("web_step_by_step", data.data.user.web_step_by_step);
    sessionStorage.setItem("today", data.now);
    sessionStorage.setItem("source_type_default", data.source_type_default);
    yield put(InitAction.getSuccess(data));
  } catch (error) {
    if (error.response && error.response.status === 403) {
      yield put(
        InitAction.getFailure(
          null,
          error.response.data && error.response.data.user_not_verified
        )
      );
      if (
        error.response.data &&
        (error.response.data.project_status_expired ||
          error.response.data.user_limit_exceeded)
      ) {
        localStorage.clear();
        sessionStorage.clear();
        checkErrorMessagesExist(error) &&
          error.response.data.message.forEach(message => {
            toastr.error(" ", message.toString());
          });
        setTimeout(() => window.location.reload(), 2000);
      } else if (error.response.data && error.response.data.user_not_verified) {
        localStorage.clear();
        sessionStorage.clear();
        deleteCookie("refreshToken");
        deleteCookie("accessToken");
      }
      // else {
      //   if (window.location.pathname !== "/verify") {
      //     // window.location.replace("/verify");
      //   }
      // }
    }
    if (error.response && error.response.status === 404) {
      yield put(InitAction.getFailure(error.response.data));
      yield put(
        InitAction.getSuccess(
          error.response.data.data,
          error.response.data.project_not_found
        )
      );
    }
    if (error.m) {
      yield put(InitAction.getFailure(null));
      localStorage.clear();
      sessionStorage.clear();
      toastr.success(" ", error.m.toString());
      setTimeout(() => window.location.reload(), 2000);
    }
  }
}

function fetchHelpStatus(status) {
  return initApi.helpStatus(status);
}

function* helpStatus(action) {
  try {
    yield call(fetchHelpStatus, action.payLoad);
  } catch (error) {}
}
